import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { getWasPatientImmbobilizedSelector } from '../selectors'
import { IonCol, IonRow, useIonViewDidEnter, useIonViewDidLeave } from '@ionic/react'
import SInput from '../../../../../components/stringInput/StringInput.component'
import {
  setCollar,
  setCID,
  setKED,
  setLBB,
  setMAST,
  saveWasPatientImmobilized,
  setPerformedBy,
  setOutcome,
} from '../store/wasPatientImmobilized.actions'
import SingleSelect from '../../../../../components/singleSelect/SingleSelect.component'
import { IOption } from '../../../../../common/common.types'
import { getWasPatientImmobilizedOptionsSelector } from '../../../../options/selectors/wasPatientImmOptions.selector'
import Validation from '../../../../../components/validation/Validation.component'
import { WasPatientImmobilizedConstants } from '../store/wasPatientImmobilized.constants'

const WasPatientImmobilized = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const wasPatientImmobilizedState = useSelector(getWasPatientImmbobilizedSelector)
  const wasPatientImmobilizedOptionsData = useSelector(getWasPatientImmobilizedOptionsSelector)
  const { immCollar, immCid, immLbb, immKed, immMast, immobBy, immobOutcome } = wasPatientImmobilizedState
  const { wasPatientImmobilizedOutcomeOptions, wasPatientImmobilizedPerformedByOptions } =
    wasPatientImmobilizedOptionsData
  const temp = [...wasPatientImmobilizedPerformedByOptions, { id: 6, name: 'Other Provider' }]

  const [wasPatientImmobilizedValidationFlag, setWasPatientImmobilizedValidationFlag] = useState(true)

  const setCollarOnChange = (e: CustomEvent) => {
    e.preventDefault()
    dispatch(setCollar(e.detail.value))
    saveWasPatientImmobilizedData()
  }

  const setCidOnChange = (e: CustomEvent) => {
    e.preventDefault()
    dispatch(setCID(e.detail.value))
    saveWasPatientImmobilizedData()
  }
  const setKedOnChange = (e: CustomEvent) => {
    e.preventDefault()
    dispatch(setKED(e.detail.value))
    saveWasPatientImmobilizedData()
  }
  const setLBBOnChange = (e: CustomEvent) => {
    e.preventDefault()
    dispatch(setLBB(e.detail.value))
    saveWasPatientImmobilizedData()
  }
  const setMastOnChange = (e: CustomEvent) => {
    e.preventDefault()
    dispatch(setMAST(e.detail.value))
    saveWasPatientImmobilizedData()
  }

  const handlePerformedByOnChange = (option: IOption) => {
    dispatch(setPerformedBy(option))
    saveWasPatientImmobilizedData()
  }

  const handleoutcomeChange = (option: IOption) => {
    dispatch(setOutcome(option))
    saveWasPatientImmobilizedData()
  }

  const saveWasPatientImmobilizedData = () => {
    dispatch(saveWasPatientImmobilized())
  }

  useEffect(() => {
    if (wasPatientImmobilizedValidationFlag) {
      immCollar && dispatch(setCollar(immCollar))
      immCid && dispatch(setCID(immCid))
      immLbb && dispatch(setLBB(immLbb))
      immKed && dispatch(setKED(immKed))
      immMast && dispatch(setMAST(immMast))
    }
  }, [wasPatientImmobilizedValidationFlag])

  useIonViewDidEnter(() => {
    setWasPatientImmobilizedValidationFlag(true)
  })

  useIonViewDidLeave(() => {
    setWasPatientImmobilizedValidationFlag(false)
  })

  return (
    <>
      <IonRow>
        <IonCol className='picklist'>
          <SInput
            label={t('neuro.wasPatientImmobilized.Collar')}
            dataTestID={t('neuro.wasPatientImmobilized.Collar')}
            inputValue={immCollar}
            onChangeAction={(e) => {
              setCollarOnChange(e)
            }}
          />
          <Validation id={WasPatientImmobilizedConstants.SET_COLLAR} />
        </IonCol>
      </IonRow>
      <hr className='field-divider' />
      <IonRow>
        <IonCol className='picklist'>
          <SInput
            label={t('neuro.wasPatientImmobilized.Cid')}
            dataTestID={t('neuro.wasPatientImmobilized.Cid')}
            inputValue={immCid}
            onChangeAction={setCidOnChange}
          />
          <Validation id={WasPatientImmobilizedConstants.SET_CID} />
        </IonCol>
      </IonRow>
      <hr className='field-divider' />
      <IonRow>
        <IonCol className='picklist'>
          <SInput
            label={t('neuro.wasPatientImmobilized.Lbb')}
            dataTestID={t('neuro.wasPatientImmobilized.Lbb')}
            inputValue={immLbb}
            onChangeAction={setLBBOnChange}
          />
          <Validation id={WasPatientImmobilizedConstants.SET_LBB} />
        </IonCol>
      </IonRow>
      <hr className='field-divider' />
      <IonRow>
        <IonCol className='picklist'>
          <SInput
            label={t('neuro.wasPatientImmobilized.Ked')}
            dataTestID={t('neuro.wasPatientImmobilized.Ked')}
            inputValue={immKed}
            onChangeAction={setKedOnChange}
          />
          <Validation id={WasPatientImmobilizedConstants.SET_KED} />
        </IonCol>
      </IonRow>
      <hr className='field-divider' />
      <IonRow>
        <IonCol className='picklist'>
          <SInput
            label={t('neuro.wasPatientImmobilized.Mast')}
            dataTestID={t('neuro.wasPatientImmobilized.Mast')}
            inputValue={immMast}
            onChangeAction={setMastOnChange}
          />
          <Validation id={WasPatientImmobilizedConstants.SET_MAST} />
        </IonCol>
      </IonRow>
      <hr className='field-divider' />
      <IonRow>
        <IonCol className='picklist' size='6'>
          <SingleSelect
            dataTestID={t('neuro.wasPatientImmobilized.PerformedBy')}
            options={temp}
            selectedOption={immobBy}
            listHeader={t('neuro.wasPatientImmobilized.PerformedBy')}
            label={t('neuro.wasPatientImmobilized.PerformedBy')}
            action={handlePerformedByOnChange}
          />
          <hr className='field-divider' />
        </IonCol>
        <IonCol className='picklist' size='6'>
          <SingleSelect
            dataTestID={t('neuro.wasPatientImmobilized.Outcome')}
            options={wasPatientImmobilizedOutcomeOptions}
            selectedOption={immobOutcome}
            listHeader={t('neuro.wasPatientImmobilized.Outcome')}
            label={t('neuro.wasPatientImmobilized.Outcome')}
            action={handleoutcomeChange}
          />
          <hr className='field-divider' />
        </IonCol>
      </IonRow>
    </>
  )
}

export default WasPatientImmobilized
